module.exports = __webpack_public_path__ + "static/media/invite_confirm_switch_teams.727880a9.png";